import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  NumPad,
  isMobile,
  wageringStore,
  useTranslation,
  useClickOutside,
  applicationStore,
  notificationStore,
  useInputValueChangingFunctions,
} from '@pascal/pascal-core';
import { betStore, freeBetStore, gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { Buttons } from '../buttons';
import { BetAmountSection } from '../betAmountSection';
import { doBetStore, gameStore } from '../../../store';
import { betAmountValidator } from '../../../helpers/supporters';
import NumPadWrapper from '../../../containers/mobile/numpadWrapper';

let mobileWrRef;

export const BetSection = observer(() => {
  const { isDemo } = applicationStore;
  const {
    isBetsClosed,
    setNumPadData,
    numPadData: { isOpen },
  } = gameStore;
  const { limits } = gameConfigStore;
  const {
    isLoadingBetButton,
    betData: { amount: betAmount },
    betInfoThisMoment: { odd },
    setBetAmount,
    doBetSender,
  } = doBetStore;
  const { activeFreeBet } = freeBetStore;
  const { partnerWageringOdd } = wageringStore;
  const { repliedBetData } = betStore;
  const [ref, hasClickedOutside] = useClickOutside();

  const [numPudInputValue, updateNumPudInputValue] = useState(limits.minBet);
  const [isValidatedAmount, setIsValidatedAmount] = useState(false);

  const { handleChangeInputValue } = useInputValueChangingFunctions({
    changingValue: betAmount,
    changingValueCallback: setBetAmount,
    additionalInputInfo: { inputType: InputTypesForChanging.BetInput },
  });
  const t = useTranslation();

  useLayoutEffect(() => {
    mobileWrRef = document.querySelector('.mobile-wr');
  }, []);

  useEffect(() => {
    if (activeFreeBet.id) {
      setBetAmount(activeFreeBet?.amount);
    } else {
      setBetAmount(repliedBetData ? repliedBetData.amount : limits.defaultBetAmount || limits.minBet);
    }
  }, [activeFreeBet, limits, setBetAmount, repliedBetData]);

  useEffect(() => {
    if (hasClickedOutside) {
      setNumPadData({ isOpen: false, currentInputValue: null });
    }
  }, [hasClickedOutside]);

  const handleInputBlur = (amount) => betAmountValidator(amount, gameConfigStore.limits);

  const validatedNumPudInputValue = (callback) => {
    const { validatedBetAmount, errorMessageCode } = handleInputBlur(numPudInputValue);
    if (errorMessageCode) {
      notificationStore.setNotificationType({ responseCode: errorMessageCode });
    }
    callback(validatedBetAmount);
  };

  const handleSubmit = useCallback(
    (isConfirmed) => {
      if (isConfirmed) {
        validatedNumPudInputValue(doBetStore.setBetAmount);
        gameStore.setNumPadData({ isOpen: false, sectionName: null, currentInputValue: null });
      }
    },
    [numPudInputValue]
  );

  const handleOpenNumPad = (event) => {
    if (isMobile()) {
      updateNumPudInputValue(event.target.value);
      gameStore.setNumPadData({
        isOpen: true,
        currentInputValue: event.target.value,
      });
    }
  };

  const decidedCallBackCall = (callback) => {
    if (isValidatedAmount) {
      setIsValidatedAmount(false);
    } else {
      return callback();
    }
    return null;
  };

  const handleClickBet = () => {
    decidedCallBackCall(() => doBetSender());
  };

  return (
    <div className='w-md-bet-action-panel'>
      <div className='w-md-bet-calc'>
        <BetAmountSection
          t={t}
          limits={limits}
          isDemo={isDemo}
          betAmount={betAmount}
          setBetAmount={setBetAmount}
          activeFreeBet={activeFreeBet}
          handleInputBlur={handleInputBlur}
          handleShowNumpad={handleOpenNumPad}
          setIsValidatedAmount={setIsValidatedAmount}
          handleChangeInputValue={handleChangeInputValue}
        />
      </div>
      <Buttons
        t={t}
        odd={odd}
        isDemo={isDemo}
        activeFreeBet={activeFreeBet}
        handleClickBet={handleClickBet}
        isBetBtnDisabled={isBetsClosed}
        wageringOdd={partnerWageringOdd}
        betPendingToggle={isLoadingBetButton}
      />
      {!activeFreeBet.id && (
        <NumPadWrapper containerRef={mobileWrRef}>
          <div ref={ref} className='numpad-wr-for-outside-click'>
            <NumPad
              t={t}
              isOpen={isOpen}
              limits={limits}
              onSubmit={handleSubmit}
              amountValue={numPudInputValue}
              setAmountValue={updateNumPudInputValue}
            />
          </div>
        </NumPadWrapper>
      )}
    </div>
  );
});
